import React, { useContext } from 'react';
import ComboBoxContext from '../ComboBoxCTX.js';
import { StyledA11yNotVisible } from './styled.js';
import { ComboboxDataTestid } from '../ComboboxDataTestids.js';
export const LiveRegion = (): JSX.Element => {
  const {
    props: { onCreate },
    hasFocus,
  } = useContext(ComboBoxContext);

  const ScreenReaderText = onCreate ? <span id="aria-creatable">press enter to create the option</span> : '';

  return (
    <StyledA11yNotVisible
      data-testid={ComboboxDataTestid.ALLY_SELECTED_VALUES}
      aria-live="polite"
      aria-atomic="false"
      aria-relevant="additions text"
    >
      {hasFocus && ScreenReaderText}
    </StyledA11yNotVisible>
  );
};

export const Announcer = React.memo(({ message }: { message: string }) => (
  <StyledA11yNotVisible aria-live="assertive" aria-relevant="all">
    {message}
  </StyledA11yNotVisible>
));
